module.exports = __webpack_public_path__ + "static/media/opensans-bold.2a6d294d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/opensans-bold.woff2
// module id = 295
// module chunks = 0